export const FETCH_BANNER_REQUEST = "FETCH_BANNER_REQUEST";
export const GENERATE_BANNER_REQUEST = "GENERATE_BANNER_REQUEST";
